import { usePreferencesUtilisateurService } from "@/features/services/preferences/usePreferencesUtilisateurService";
import type { PreferencesService } from "@/features/application/preferences/";

export type PreferenceKey = string

export function usePreferencesUtilisateur<T>(path: PreferenceKey) {
    const preferencesServices: PreferencesService = usePreferencesUtilisateurService()

    async function getPreferencesAsync(): Promise<T | undefined> {
        const result: any = await preferencesServices.loadAsync()
        return result?.[path] as T | undefined
    }

    async function setPreferencesAsync(patch?: Partial<T>): Promise<void> {
        const result = await preferencesServices.loadAsync() as any
        if (patch === undefined) {
            delete result[path]
        } else {
            result[path] = {
                ...result[path],
                ...patch
            }
        }

        await preferencesServices.saveAsync(result)
    }

    return { getPreferencesAsync, setPreferencesAsync }
}

